<template>
  <v-app>

    <v-content>
      <app-Navigation></app-Navigation>
      <router-view></router-view>
      <app-Footer></app-Footer>
    </v-content>

  </v-app>
</template>

<script>
import Navigation from './components/navigation.vue'
import Footer from './components/footer.vue'

export default {
  components: {
    appNavigation: Navigation,
    appFooter: Footer
  }
}
</script>
